export default __webpack_public_path__ + "static/media/zoom-in.2160c496.svg";